export default "__VITE_ASSET__BFXhAPHI__"